<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <b-form-group class="w-50 mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Wyszukaj zgłoszenie" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="cooperationRecords"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn">
      <template #cell(actions)="row">
        <div class="d-flex flex-column align-items-center">
          <b-button
            :to="{ name: 'cooperation-show', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Zobacz
          </b-button>
          <b-button class="mt-1 table-btn" variant="danger" size="sm" @click="destroy(row.item)"> Usuń </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all, destroy } from '@/http/cooperation';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      cooperationRecords: [],
      filter: '',
      filterOn: [],
      fields: [
        { key: 'fullname', label: 'Zgłaszający', sortable: true },

        { key: 'email', label: 'Email', sortable: true },
        { key: 'phone', label: 'Telefon', sortable: true },
        { key: 'topic', label: 'Temat', sortable: true },
        { key: 'created_at', label: 'Data zgłoszenia', sortable: true },
        { key: 'actions', label: 'Akcje', class: 'w-25' },
      ],
    };
  },

  async mounted() {
    this.fetchCooperationRecords();
  },

  methods: {
    async fetchCooperationRecords() {
      try {
        const { data } = await all();

        this.cooperationRecords = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem zgłoszeń współpracy. Skontaktuj się ze swoim developerem.',
        );
      }
    },
    destroy(coopeartionRecord) {
      this.$swal({
        title: 'Jesteś pewny?',
        text: 'Czy chcesz usunąć te zgłoszenie?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        cancelButtonText: 'Anuluj',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          destroy(coopeartionRecord.id)
            .then(() => {
              this.showSuccessNotification('Zgłoszenie usunięte', 'Zgłoszenie współpracy zostało usunięte.');
              this.fetchCooperationRecords();
            })
            .catch(() => {
              this.showErrorNotification(
                'Problem z usunięciem danych',
                'Wystąpił problem z usunięciem zgłoszenia współpracy. Skontaktuj się ze swoim developerem.',
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
